import type { InstitutionCustomFields } from "@/shared/types/institutions";

/** Evita crash quando `name` / `nome_fantasia` vêm nulos no banco (legado / importação). */
export function tituloExibicaoInstituicao(i: { nome_fantasia: string | null; name: string | null }): string {
  const s = `${i.nome_fantasia ?? ""}`.trim() || `${i.name ?? ""}`.trim();
  return s.length > 0 ? s : "Instituição sem nome";
}

export function normalizarCustomFieldsInstituicao(raw: unknown): InstitutionCustomFields {
  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    return raw as InstitutionCustomFields;
  }
  return {};
}
